module.exports = __webpack_public_path__ + "img/home-background.15483339.png";